const orderMixerFields = mixerObj => {
  if (!mixerObj || typeof mixerObj !== "object") return mixerObj;

  const orderedMixer = {};

  const mixerFieldOrder = ["auto", "video", "audio", "preselected", "score"];

  mixerFieldOrder.forEach(field => {
    if (mixerObj.hasOwnProperty(field)) {
      orderedMixer[field] = mixerObj[field];
    }
  });

  Object.keys(mixerObj).forEach(key => {
    if (!orderedMixer.hasOwnProperty(key)) {
      orderedMixer[key] = mixerObj[key];
    }
  });

  return orderedMixer;
};

const orderStreamSourceFields = sourceObj => {
  if (!sourceObj || typeof sourceObj !== "object") return sourceObj;

  const orderedSource = {};

  const sourceFieldOrder = ["label", "cam_id", "url", "exp_camera_url", "exp_camera_cfg", "steerable"];

  sourceFieldOrder.forEach(field => {
    if (sourceObj.hasOwnProperty(field)) {
      orderedSource[field] = sourceObj[field];
    }
  });

  Object.keys(sourceObj).forEach(key => {
    if (!orderedSource.hasOwnProperty(key)) {
      orderedSource[key] = sourceObj[key];
    }
  });

  return orderedSource;
};

export const orderFileFields = fileObj => {
  if (!fileObj || typeof fileObj !== "object") return fileObj;

  const orderedFile = {};

  const fieldOrder = [
    "type",
    "name",
    "set_dns_names",
    "deployment_id",
    "allow_concurrent_events",
    "version",
    "ami",
    "instance",
    "instances",
    "output_fps",
    "output_size",
    "video_proxy",
    "mixer2",
    "fluentbit",
    "logs_keeper",
    "logs_keeper_config",
    "virtualcam",
    "stream_sources",
    "video_drains",
    "mixer",
  ];

  fieldOrder.forEach(field => {
    if (fileObj.hasOwnProperty(field)) {
      if (field === "mixer") {
        orderedFile[field] = orderMixerFields(fileObj[field]);
      } else if (field === "stream_sources" && Array.isArray(fileObj[field])) {
        orderedFile[field] = fileObj[field].map(source => orderStreamSourceFields(source));
      } else {
        orderedFile[field] = fileObj[field];
      }
    }
  });

  Object.keys(fileObj).forEach(key => {
    if (!orderedFile.hasOwnProperty(key)) {
      orderedFile[key] = fileObj[key];
    }
  });

  return orderedFile;
};
